export enum ApiRoutes {
  Auth = '/ar/authentication/tokenauth',
  PastDueInvoices = '/ar/invoices/pastdue',
  PendingDueInvoices = '/ar/invoices/pending',
  AllInvoices = `/ar/invoices/all`,
  DisputedReasons = '/ar/disputedreasons',
  UpdateBulkInvoiceCollectionStatus = '/ar/collectionsstatus/bulkupdate',
  DebtorCredentials = '/authorization/debtorids',
  SearchInvoices = '/ar/invoices/search',
  InvoicesSummary = '/ar/invoices/summary',
  UpdateFeedback = '/ar/invoices/feedback',
  SearchInvoiceDocuments = '/search/invoices/:assetId/documents',
  SearchInvoiceActivities = '/search/invoices/:assetId/activities',
  DebtorCredential = '/authorization/credential/debtor',
  DebtorSearch = '/debtors/search',
  DebtorSettings = '/debtors/:debtorId/settings',
  Companies = '/ar/companies',
  DebtorCreditUtilization = '/credits/debtor/:debtorId/credit-utilization',
  ResendActivation = '/authorization/users/resend-activation',
  ArFeatures = '/ar/features',
  AllInvoicesSearch = '/ar/invoices/all/search',
  AllInvoicesSearchFilters = '/ar/invoices/all/search/filters',
  // NOA Center (FACOPS-2722) — routes are provisional until the backend lands.
  NoaCarrierSearch = '/noa/carriers/search',
  NoaCarrierDetail = '/noa/carriers/:carrierId',
  NoaDocumentDownload = '/noa/documents/:documentId',
  // Communication Preferences (FACOPS-3992 / API FACOPS-3990) — provisional until the
  // gateway path is published. api-version 2.0; debtorId/companyId travel as headers.
  CommunicationPreferencesSchedule = '/ar/communicationpreferences/schedule',
  CommunicationPreferencesDestinations = '/ar/communicationpreferences/destinations',
};